import { CloseButton } from "src/atoms/CloseButton";
import { ModalWrapper } from "./EmailValidationModal.styled";
import { AlertCircleIcon } from "src/icons";
import { useSession } from "next-auth/react";
import { Button } from "src/atoms/Button";
import { Trans } from "@lingui/macro";
import Link from "next/link";
import { useMemo } from "react";
import { Modal } from "src/atoms/Modal";

type EmailValidationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onProceedToCheckout: () => void;
};

function EmailValidationModal({
  isOpen,
  onClose,
  onProceedToCheckout,
}: EmailValidationModalProps): JSX.Element {
  const { data: session } = useSession();
  const email = useMemo(() => session?.user?.email || "", [session]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} fullHeight={false} centerOnScreen>
      <ModalWrapper>
        <div className="title-wrapper">
          <h2>
            <AlertCircleIcon />
            <Trans>Is your email correct?</Trans>
          </h2>
          <CloseButton onClick={onClose} />
        </div>
        <div className="content-wrapper">
          <p>
            <Trans>
              Hmm… <b>{email}</b> doesn&#39;t look quite right. Please update to
              continue.
            </Trans>
          </p>
          <div className="button-group">
            <Button variant="secondary" fullWidth onClick={onProceedToCheckout}>
              <Trans>Continue to checkout</Trans>
            </Button>
            <Link href="/my-profile#change-email">
              <Button fullWidth>
                <Trans>Update now</Trans>
              </Button>
            </Link>
          </div>
        </div>
      </ModalWrapper>
    </Modal>
  );
}

export { EmailValidationModal };
